
export const KEY_FBSPORT = '___KEY_FBSPORT__'
export const KEY_SEARCH_LEAGUE = '___KEY_SEARCH_LEAGUE__'
export const KEY_FBREQTIME = '___KEY_FBREQTIME__'
